// src/components/about/GallerySlider.jsx
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const captions = [
  "Where Silence Becomes Medicine",
  "Spaces That Breathe With You",
  "Gardens That Heal The Soul",
  "Food As Your Personal Elixir"
];

export default function GallerySlider({ currentIndex, setCurrentIndex, isPaused, setIsPaused, images }) {
  const nextSlide = () => setCurrentIndex((i) => (i + 1) % images.length);
  const prevSlide = () => setCurrentIndex((i) => (i - 1 + images.length) % images.length);

  return (
    <section className="py-32 bg-[#EBE0CF] relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-[#0B2A2C] text-sm tracking-widest uppercase mb-4">Moments of Transformation</p>
          <h2 className="text-5xl md:text-6xl font-bold text-[#0B2A2C]">A Sanctuary in Motion</h2>
        </div>

        <div 
          className="relative rounded-3xl overflow-hidden shadow-2xl"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div className="relative h-[400px] md:h-[600px]">
            {images.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`Gallery ${idx + 1}`}
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
                  idx === currentIndex ? 'opacity-100' : 'opacity-0'
                }`}
              />
            ))}

            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent">
              <div className="absolute bottom-0 left-0 right-0 p-12 text-white">
                <p className="text-3xl md:text-5xl font-light tracking-wide max-w-4xl">
                  {captions[currentIndex]}
                </p>
                <p className="text-emerald-300 mt-4 text-lg opacity-80">
                  {currentIndex + 1} / {images.length}
                </p>
              </div>
            </div>

            <button onClick={prevSlide} className="absolute left-8 top-1/2 -translate-y-1/2 w-16 h-16 bg-white/10 backdrop-blur-md hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 border border-white/20 group">
              <ChevronLeft className="w-8 h-8 text-white group-hover:scale-110 transition" />
            </button>
            <button onClick={nextSlide} className="absolute right-8 top-1/2 -translate-y-1/2 w-16 h-16 bg-white/10 backdrop-blur-md hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 border border-white/20 group">
              <ChevronRight className="w-8 h-8 text-white group-hover:scale-110 transition" />
            </button>

            <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-4">
              {images.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentIndex(idx)}
                  className={`transition-all duration-500 ${
                    idx === currentIndex 
                      ? 'w-16 h-2 bg-emerald-400 rounded-full' 
                      : 'w-2 h-2 bg-white/50 rounded-full hover:bg-white/80'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>

        
      </div>
    </section>
  );
}